// @flow
import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getTestAb = (state: Object) => get(state, ['trovit', 'abTest']);

export const getSpecificTestAbOption = (
  state: Object,
  id: string,
  option: string
): { id: string, option: string } => ({ id, option });

export const isSpecificTestAbOption = createSelector<Object, *, *, *, *>(
  [getTestAb, getSpecificTestAbOption],
  (testAb: Object, specificTest: { id: string, option: string }) => {
    if (
      testAb != null &&
      Number(testAb.id) === Number(specificTest.id) &&
      typeof testAb.option === 'string'
    ) {
      return testAb.option.toLowerCase() === specificTest.option.toLowerCase();
    }

    return false;
  }
);



// WEBPACK FOOTER //
// ./app/TestAb/selectors.js